import { render, staticRenderFns } from "./home-box4.vue?vue&type=template&id=3d378217&scoped=true&"
import script from "./home-box4.vue?vue&type=script&lang=js&"
export * from "./home-box4.vue?vue&type=script&lang=js&"
import style0 from "./home-box4.vue?vue&type=style&index=0&id=3d378217&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d378217",
  null
  
)

export default component.exports